import React from 'react';
import './Calibration.scss';
import { useBem } from '../Bem';
import { QueryClient } from 'react-query';
import { CalibrationForm } from './CalibrationForm';
import { InfoScreen } from './InfoScreen';
import { useIntl } from 'react-intl';
import { CalibrationIntl } from './Calibration.intl';
import { useToken, useUserInfo, closeAppDialog } from './helper';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

export const Calibration = () => {
  const bem = useBem('calibration');
  const intl = useIntl();
  const token = useToken();
  const { hasUserError, userInfo } = useUserInfo();

  if (!token || hasUserError) {
    return (
      <InfoScreen
        type={intl.formatMessage(CalibrationIntl.error)}
        message={intl.formatMessage(CalibrationIntl.errorAccessMessage)}
        action={{
          title: intl.formatMessage(CalibrationIntl.close),
          method: () => closeAppDialog(),
        }}
      />
    );
  }

  return (
    <div className={bem.elem('steps-container').cls()}>
      <CalibrationForm />
    </div>
  );
};
